import React, { useContext } from 'react';
import { Modal } from 'antd';
import TableForm from './TableForm';
import StoreVariantsContext from '../../../contexts/store-variants/VariantsContextPage';
import { useTranslation } from 'react-i18next';

const SettingsWorkPlaceModal = () => {
  const { modalOpened, setModalOpened, setSelectedUnit, selectedUnit } =
    useContext(StoreVariantsContext);
  const { t } = useTranslation();

  return (
    <Modal
      transitionName=""
      className="work-places-modal shared-custom-modal"
      width="90%"
      style={{ maxWidth: '742px' }}
      title={
        selectedUnit
          ? t('Inventory.VariantsTypes.modifyVariantType')
          : t('Inventory.VariantsTypes.addNewVariantType')
      }
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedUnit(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedUnit(null);
      }}
      footer={false}
    >
      <TableForm />
    </Modal>
  );
};

export default SettingsWorkPlaceModal;
